﻿import { useQuery } from '@tanstack/react-query';
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes, InvoicePropertyDisplayNames } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import HistorySection from '../common/history/HistorySection';
import HistoryTypeSelect from '../common/history/HistoryTypeSelect';

const invoiceHistorySections = [
    {
        key: 'general',
        heading: 'General Information',
        renderOptions: { propertyDisplayNames: InvoicePropertyDisplayNames },
    },
    {
        key: 'timesheetLinks',
        heading: 'Timesheets',
        renderOptions: {
            simpleDate: true,
            propertyDisplayNames: InvoicePropertyDisplayNames,
        },
    },
    {
        key: 'summaries',
        heading: 'Summary Lines',
        renderOptions: { propertyDisplayNames: InvoicePropertyDisplayNames },
    },
    {
        key: 'exports',
        heading: 'Exports',
        renderOptions: { propertyDisplayNames: InvoicePropertyDisplayNames },
    },
];

const invoiceHistoryTypeOptions = [
    { value: 'all', label: 'All versions' },
    ...invoiceHistorySections.map((section) => ({
        value: section.key,
        label: section.filterLabel ?? section.heading,
    })),
];

const InvoiceHistoryForm = ({
    id = 'invoiceHistoryForm', show, invoiceId, onClose,
}) => {
    const { data: fullHistory = {}, isFetching: loading } = useQuery({
        queryKey: ['invoiceFullHistory', invoiceId],
        queryFn: () => httpClient.js(ApiRoutes.invoiceHistory.byId(invoiceId)),
        enabled: show && Boolean(invoiceId),
    });

    return (
        <SlideForm
            loading={loading}
            show={show}
            id={id}
            formIcon={faTasks}
            formTitle="Invoice History"
            onClose={onClose}
            initialValues={{ versionHistorySection: 'all' }}
            saveDisabled
            className="history-form"
        >
            {({ values }) => {
                const selectedSection = values.versionHistorySection ?? 'all';

                return (
                    <div className="w-100">
                        <HistoryTypeSelect options={invoiceHistoryTypeOptions} />

                        <HistorySection
                            historicalChangeCollection={fullHistory[selectedSection]}
                            renderOptions={{ propertyDisplayNames: InvoicePropertyDisplayNames }}
                        />
                    </div>
                );
            }}
        </SlideForm>
    );
};

export default InvoiceHistoryForm;
